import { Link } from "react-router-dom";
import { ArrowRight, Ear, Activity, Volume2, Wind, Moon, Mic, Headphones, Brain } from "lucide-react";

const iconMap = {
  ear: Ear,
  activity: Activity,
  "volume-2": Volume2,
  wind: Wind,
  moon: Moon,
  mic: Mic,
  headphones: Headphones,
  brain: Brain,
};

export default function ServiceCard({ service }) {
  const IconComponent = iconMap[service.icon] || Ear;
  
  const getHref = () => {
    if (service.slug === "cochlear-implant") return "/cochlear-implant";
    return `/services#${service.slug}`;
  };

  return (
    <Link 
      to={getHref()}
      className="service-card group block"
      data-testid={`service-card-${service.slug}`}
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-sky-50 flex items-center justify-center flex-shrink-0 group-hover:bg-sky-100 transition-colors">
          <IconComponent className="w-6 h-6 text-sky-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-heading font-semibold text-slate-900 text-lg mb-2 group-hover:text-sky-600 transition-colors">
            {service.title}
          </h3>
          <p className="text-slate-600 text-sm leading-relaxed line-clamp-2">
            {service.short_description}
          </p>
          <div className="mt-4 flex items-center gap-2 text-sky-600 text-sm font-medium">
            <span>Learn more</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </div>
        </div>
      </div>
      
      {service.is_featured && (
        <div className="mt-4 pt-4 border-t border-slate-100">
          <span className="badge-featured">Most Requested</span>
        </div>
      )}
    </Link>
  );
}
